import * as MUI from "@mui/material";

export default function SectionLabel({ children }) {
  return (
    <MUI.Typography
      variant="overline"
      color="text.secondary"
      sx={{ fontWeight: 700, letterSpacing: "0.06em" }}
    >
      {children}
    </MUI.Typography>
  );
}
